/**
 * @module Experience/repdash
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const REPDASH_CONSTANTS = {
  PASSWORD_EXPIRY_IN_DAYS: 90,
  REPDASH_MODULE: 'RepdashModule',
  CUSTOMER_ORDER_LOOKUP_SERVICE: 'CustomerOrderLookupservice',
  LOOKUP_SERVICE: 'LookupService',
  PASSWORD_EXPIRY_UPPER_LIMIT: 15,
  PASSWORD_EXPIRY_LOWER_LIMIT: 7,
  MYFOLLOWUP_CODE: 'ZTFO',
  MYTEAMFOLLOWUP_CODE: 'ZTFO',
  MYADJUSTMENT_CODE: 'ZTCR%2CZTAD',
  MYTEAMADJUSTMENT_CODE: 'ZTCR%2CZTAD',
  ASSIGNED_TO_ME: 'me',
  ASSIGNED_TO_MYTEAM: 'myTeam',
  TICKETS_UPPERLIMIT: 99,
  TICKETS_UPPERLIMIT_IDENTIFIER: '99+',
  CART: '/cart',
  ACCOUNT_LANDING: '/account-landing',
  ORDER_SUMMARY: '/order-summary',
  CART_REVIEW: 'cart/review',
  NEGATIVE: -1,
  CART_ORDER_SUMMARY: '/cart-order-summary',
  RESULT_TYPE: 'CART',
};

export const REPDASH_SCREENID_CONSTANTS = {
  USAGE_SUMMARY_LANDING: 'USAGE_SUMMARY',
  DEFAULT: 'SC1135',
};

export const REPDASH_MODULE_COMPONENTS = {
  REPDASH_MODULE_NAME: 'Repdash Module',
  ACTIVITY_LOG_COMPONENT: 'ActivityLogComponent',
  ACTIVITY_LOG_FILTER_SORT_COMPONENT: 'ActivityLogFilterSortComponent',
  ACTIVITY_LOG_FILTER_SERVICE: 'RepdashActivityLogFilterService',
  REPDASH_MODULE: 'Repdash',
  REPDASH_COMPONENT: 'RepdashComponent',
  MRC_SUMMARY_COMPONENT: 'MrcSummaryComponent',
  MRC_SUMMARY_SERVICE: 'MrcSummaryService',
  USAGE_MODULE: 'UsageModule',
  VERIFICATION_CARE_COMPONENT: 'VerificationCareComponent',
  VERIFICATION_RETAIL_COMPONENT: 'VerificationRetailComponent',
  TIME_OUT_MODAL_COMPONENT: 'TimeOutModalComponent',
  CUSTOMER_ORDER_LOOKUP_SERVICE: 'CustomerOrderLookupService',
  USAGE_SUMMARY_SERVICE: 'UsageSummaryService',
};

export const USER_DATA_CONSTANTS = {
  COLON: ':',
  SPACE: ' ',
  GUEST: 'Guest Customer',
  NOT_APPLICABLE: 'N/A',
  UNVERIFIED: 'Unverified',
  UNKNOWN_MSISDN: '(XXX)XXX-XXXX',
  UNKNOWN: 'Unknown',
  VERIFIED: 'Verified',
  FAVORITES: 'favorites',
  HASH: '#',
};

export const AUDIT_DRAWER_CONSTANTS = {
  PREPAID: 'prepaid',
  POSTPAID: 'postpaid',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  SUSPENDED: 'SUSPENDED',
  MONTHS: 'm',
  DAYS: 'd',
  YEARS: 'y',
  GUEST: 'Guest',
  GUESTCHECK: 'Guest Customer',
  REPDASH_MODULE: 'RepdashModule',
  DATE_FORMAT: 'MM/dd/yyyy',
  UNKNOWN: 'Unknown',
  LOCKED: 'Locked',
  UNLOCKED: 'Unlocked',
  DEVICE: 'Device:',
};

export const SIGN_OUT_CONSTANTS = {
  SIGN_OUT: '/signout',
  RETAIL: '/retail',
  CARE: '/care',
};

export const IVR_CARE_CONSTANTS = {
  CUSTOMER_CARE_SALES_CODE: '0000000',
  SHADOW_PIN: '1111',
  PIN: 'PIN',
  YES: 'v',
  USER_MEMO: 'UserMemo',
};
